<template>
	<a class="social-button-link" :href="url">
		<div class="button">
			<div class="image-container">
				<img
					v-if="text.toLowerCase() === 'facebook'"
					src="../assets/FacebookLogo.svg"
					:alt="`${text} logo`"
				/>
				<img
					v-if="text.toLowerCase() === 'google'"
					src="../assets/GoogleLogo.svg"
					:alt="`${text} logo`"
				/>
			</div>
			<div class="text-container">
				<p>{{ text }}</p>
			</div>
		</div>
	</a>
</template>

<script>
	export default {
		props: ["logo", "text", "url"],
	};
</script>

<style lang="scss" scoped>
	.social-button-link {
		@include flex(row, center, center);
		width: 100%;
		text-decoration: none;
		color: var(--color-darker);

		&:hover {
			text-decoration: none;
		}

		.button {
			width: 100%;
			height: 44px;
			padding: 0px 10px;
			@include flex(row, center, center);
			border: none;
			box-shadow: #b0b0b0 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;
			-webkit-box-shadow: #b0b0b0 0px 0px 0px 1px inset, 0 0 0px 1000px var(--color-white) inset;
			color: var(--color-darker);
			font-weight: var(--fw-600);
			font-family: var(--font-sora);
			font-size: 14px;
			border-radius: 8px;
			@include transition(all .2s);

			&:hover {
				text-decoration: none;
				background-color: #fff;
				box-shadow: #222222 0px 0px 0px 2px inset, 0 0 0px 1000px var(--color-white) inset;
				-webkit-box-shadow: #222222 0px 0px 0px 2px inset, 0 0 0px 1000px var(--color-white) inset;
				color: var(--color-black);
			}

			.image-container {
				width: 20px;
				height: 20px;
				@include flex(row, center, center);
				padding: 1px;
				margin-right: 5px;

			}
		}

		.text-container {
			text-decoration: none;

			p{
				text-decoration: none;
				line-height: 1em;
			}
		}
	}
</style>